module.exports = __webpack_public_path__ + "core-img/info-bg.8bd7f5d7b65fcf986a6993806c391ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/images/debug-renderer/info-bg.png
// module id = 75
// module chunks = 0